import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-truncate-text',
  imports: [],
  templateUrl: './truncate-text.component.html',
  styleUrl: './truncate-text.component.scss'
})
export class TruncateTextComponent {
  @Input() text = '';
  @Input() limit = 100;

  isExpanded = false;

  get truncatedText(): string {
    if (this.text.length <= this.limit) {
      return this.text;
    }
    return this.text.substring(0, this.limit) + '...';
  }

  toggle(event: Event): void {
    event.stopPropagation();
    this.isExpanded = !this.isExpanded;
  }
}
